import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';




declare let document: any;


@Injectable({
  providedIn: 'root'
})
export class ScriptloaderService {

  private loaded: string[] = [];



  loadScript(src: string): Observable<void> {
    return new Observable((_observer) => {
      if (this.loaded.indexOf(src) === -1) {
        //load script
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        if (script.readyState) {  //IE
          script.onreadystatechange = () => {
            if (script.readyState === "loaded" || script.readyState === "complete") {
              script.onreadystatechange = null;
              this.loaded.push(src);
              _observer.next();
              _observer.complete();
            }
          };
        } else {  //Others
            script.onload = () => {
              this.loaded.push(src);
              _observer.next();
              _observer.complete();
            };
        }
        script.onerror = (error: any) => _observer.error();
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        _observer.next();
        _observer.complete();
      }
    });
  }
}
